import { useId } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LANGS, localizePath, useLang } from "@/i18n";

// Drapeaux en SVG (rendu identique sur tous les systèmes, contrairement aux émojis)
function Flag({ code }) {
  const uid = useId().replace(/:/g, "");
  if (code === "fr") return <svg viewBox="0 0 3 2" className="w-full h-full"><rect width="1" height="2" fill="#002395" /><rect x="1" width="1" height="2" fill="#fff" /><rect x="2" width="1" height="2" fill="#ED2939" /></svg>;
  if (code === "it") return <svg viewBox="0 0 3 2" className="w-full h-full"><rect width="1" height="2" fill="#009246" /><rect x="1" width="1" height="2" fill="#fff" /><rect x="2" width="1" height="2" fill="#CE2B37" /></svg>;
  if (code === "de") return <svg viewBox="0 0 5 3" className="w-full h-full"><rect width="5" height="1" fill="#000" /><rect y="1" width="5" height="1" fill="#DD0000" /><rect y="2" width="5" height="1" fill="#FFCE00" /></svg>;
  return (
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
      <clipPath id={`s${uid}`}><path d="M0,0 v30 h60 v-30 z" /></clipPath>
      <clipPath id={`t${uid}`}><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
      <g clipPath={`url(#s${uid})`}>
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#t${uid})`} stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}

export default function LanguageSwitcher({ className = "", size = "md", testIdPrefix = "lang" }) {
  const lang = useLang();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const dims = size === "lg" ? "w-9 h-6" : "w-6 h-4";
  const go = (code) => {
    if (code === lang) return;
    try { localStorage.setItem("lang-pref", code); } catch { /* navigation privée */ }
    navigate(`${localizePath(pathname, code)}${search}${hash}`);
  };
  return (
    <div className={`flex items-center gap-0 shrink-0 ${className}`} role="group" aria-label="Langue / Language" data-testid={`${testIdPrefix}-switcher`}>
      {LANGS.map((l) => (
        <button key={l.code} type="button" onClick={() => go(l.code)} lang={l.htmlLang} title={l.label} aria-label={l.label} aria-current={l.code === lang ? "true" : undefined}
          data-testid={`${testIdPrefix}-${l.code}`}
          className="group p-2 sm:p-1.5 -m-0.5 rounded-md shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold">
          <span className={`${dims} block rounded-[3px] overflow-hidden transition-all duration-200 ${l.code === lang ? "ring-2 ring-forest ring-offset-2 ring-offset-ecru opacity-100" : "opacity-60 group-hover:opacity-100 group-hover:-translate-y-px shadow-sm"}`}>
            <Flag code={l.code} />
          </span>
        </button>
      ))}
    </div>
  );
}
